"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const navigation_html_1 = require("./navigation.html");
const d3_1 = require("d3");
class Navigation2 //implements Controller<NavigationArgs, HTMLElement>
 {
    constructor(view, model) {
        this.updateLang = (langId, lang) => {
            this.model.currentlang = langId;
            document.body.lang = this.model.currentlang;
            this.model.onLangChange(this.model.currentlang);
        };
        this.view = view;
        this.model = model;
        this.view.ui = navigation_html_1.NavigationHTML({
            parent: this.view.parent,
            onNextClick: {},
            onPrevClick: {},
            onLangChange: this.updateLang,
            onQuery: {}
        });
        this.view.ui.updateLangs(this.model.languages);
        if (this.model.path)
            this.updateBreadcrumbView(this.model.path);
        model.content(this.view.ui.content);
    }
    updateBreadcrumbView(path) {
        this.view.ui.breadcrumb.innerHTML = '';
        d3_1.select(this.view.ui.breadcrumb)
            .selectAll('a')
            .data(path.slice(1))
            .enter().append('a')
            .classed('breadcrumb', true)
            .attr('href', d => d.href)
            .attr('target', d => d.target)
            .text(d => d.label.split('-').join(' '));
    }
}
exports.Navigation2 = Navigation2;



//////////////////
// WEBPACK FOOTER
// ./dist/js/components/navigation/navigation2.js
// module id = 1037
// module chunks = 0